import { useEffect, useState } from "react";
import Illustration from "../../assets/images/hero-illustration-desktop.svg";
import profileIcon from "../../assets/icons/profile.svg"
import whiteProfileIcon from "../../assets/icons/whiteProfile.svg"
import IslamicDate from "../../components/islamicDate";
import Button from "../../components/button";
import add from "../../assets/icons/whiteAddCampaignIcon.svg";
import articleIcon from "../../assets/icons/article.svg";
import streetwise from "../../assets/images/Streetwise-Muslim.png";
import tvShowThumbnail from "../../assets/images/Aminah.jpg";
import play from "../../assets/icons/roundedPlay.svg";
import { useSelector } from "react-redux";
import { useTotalAmount } from "../reuseableEffects";
import { Link } from "react-router-dom";
import Spinner from "../../components/Spinners/inlineSpinner";

const Dashboard = ({setPageTitle}) => {
    
    useEffect(() => {
        setPageTitle("Dashboard");
        document.title="Dashboard - Mosquepay"
      },[setPageTitle]);

      const thumbnail1 = "https://img.freepik.com/free-photo/person-conducting-interview_23-2149037959.jpg?t=st=1724534539~exp=1724538139~hmac=45047cb1d8ee0626490fc9a1689ea4088eb5e598c0dbc739f9aacf5e0df8d9c8&w=826"
  
       const userSessionData = useSelector((state) => state.user.userSession);
       const userName = userSessionData.user_details[0].username

       const Stats = useTotalAmount()
       const totalAmountRaised = Stats[0]?.amount
       const totalDonations = Stats[0]?.txn_counts

       
    const loading = useSelector((state) => state.user.loading);

  

    return ( 
        <div className="grid gap-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
            <div className="grid md:hidden gap-4 w-full mb-4">
              <div>
                <div className="flex gap-1">
                  <span className="text-black/60">Salaam Alaykum,</span>
                  <span>{userName}</span>
                </div>
                <div>
                  <IslamicDate />
                </div>
              </div>
              <div className="flex gap-8">
                <Button  buttonText={"Create a campaign"} otherStyles={"text-white bg-black"} buttonRole={"link"} icon={add} destination={"/dashboard/start-a-campaign"}/>
                  <Link to={"/dashboard/profile"} className="flex items-center gap-3 ">
                      <img src={profileIcon} alt="" className="h-5"/>
                      <span className="text-sm">My profile</span>
                  </Link>
              </div>
            </div>
            <div className="lg:col-span-7 bg-black rounded-md hidden md:grid grid-cols-1 md:grid-cols-2 md:gap-6">
              <div className="p-4 md:p-8 flex items-center">
                <div className="grid gap-4 w-full justify-center md:justify-start">
                  <div className="grid gap-1">
                    <div className="flex gap-2 md:gap-0 md:grid text-center md:text-start">
                      <span className="text-sm text-white md:text-white/60">Salaam Alaykum,</span>
                      <span className="text-white">{userName}</span>
                    </div>
                    <div>
                      <IslamicDate />
                    </div>
                  </div>
                  <div className="flex">
                    <Link to={"/dashboard/profile"} className="flex items-center gap-2">
                      <img src={whiteProfileIcon} alt="" className="h-4"/>
                      <span className="text-sm text-white">My profile</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="flex items-end h-full"><img src={Illustration} alt="" className="w-full"/></div>
              </div>
            </div>
            <div className="lg:col-span-5 border rounded overflow-hidden relative">
                 <div className="absolute top-0 w-full px-4 py-3 border-b bg-secondaryBackground text-[15px]">
                   <span className="text-secondary">Platform statistics:</span>
                 </div>
                 <div className="flex items-center h-full pt-12">
                   <div className="p-4 grid grid-cols-2 gap-4 w-full">
                     <div className="grid">
                      <span className="text-sm text-secondary">Total amount raised:</span>
                      <span className="font-medium"> {loading ? <Spinner /> : <span>{totalAmountRaised}</span>} </span>
                     </div>
                     <div className="grid">
                      <span className="text-sm text-secondary">Donations:</span>
                      <span className="font-medium">{loading ? <Spinner /> : <span>{totalDonations}</span>}</span>
                     </div>
                     <div className="grid">
                      <span className="text-sm text-secondary">Campaigns:</span>
                      <span className="font-medium">91</span>
                     </div>
                   </div>
                 </div>
            </div>
          </div>
          {/* <div>
            <p className="font-semibold mb-2">Articles:</p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white border rounded p-4 grid gap-2">
                <img src={articleIcon} alt="" className="h-5"/>
                <span className="text-[15px] mb-4">How to run a successful fundraising campaign on Mosquepay.</span>
                <span className="text-sm text-brandGreen">Read article</span>
              </div>
              <div className="bg-white border rounded p-4 grid gap-2">
                <img src={articleIcon} alt="" className="h-5"/>
                <span className="text-[15px] mb-4">How to run a successful fundraising campaign on Mosquepay.</span>
                <span className="text-sm text-brandGreen">Read article</span>
              </div>
              <div className="bg-white border rounded p-4 grid gap-2">
                <img src={articleIcon} alt="" className="h-5"/>
                <span className="text-[15px] mb-4">How to run a successful fundraising campaign on Mosquepay.</span>
                <span className="text-sm text-brandGreen">Read article</span>
              </div>
              <div className="bg-white border rounded p-4 grid gap-2">
                <img src={articleIcon} alt="" className="h-5"/>
                <span className="text-[15px] mb-4">How to run a successful fundraising campaign on Mosquepay.</span>
                <span className="text-sm text-brandGreen">Read article</span>
              </div>
            </div>
          </div> */}
          <div>
            <p className="font-semibold mb-2">Entertainment:</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="grid lg:flex border rounded overflow-hidden">
                <img src={streetwise} alt="" className="w-full aspect-video md:h-56 lg:w-40 lg:h-auto lg:aspect-square object-cover"/>
                <div className="p-4 grid gap-2 content-between">
                  <div>
                    <img src={play} alt="" className="h-5"/>
                    <div className="mt-2">Streetwise Muslim: Faith isn’t separate from life — it shapes it.</div>
                    <div className="text-[15px] text-secondary">Streetwise Muslim explores how Islamic values guide us through each moment.</div>
                  </div>
                  <Link to={"https://www.youtube.com/playlist?list=PLBDpImb7W8w4TmlhGvqe455LoZtdLxjSX"} target="_blank" className="underline text-sm text-brandGreen">
                    Watch episodes
                  </Link>
                </div>
              </div>
              <div className="grid lg:flex border rounded overflow-hidden">
                <img src={tvShowThumbnail} alt="" className="w-full aspect-video md:h-56 lg:w-40 lg:h-auto lg:aspect-square object-cover"/>
                <div className="p-4 grid gap-2 content-between">
                  <div>
                    <img src={play} alt="" className="h-5"/>
                    <div className="mt-2">Halalnest show: Empowering Muslims with halal financial knowledge.</div>
                    <div className="text-[15px] text-secondary">Welcome to the HalalNest Show — where faith meets wealth.</div>
                  </div>
                  <Link to={"https://www.youtube.com/playlist?list=PLBDpImb7W8w720p9m42cIvyXi-rElRTzH"} target="_blank" className="underline text-sm text-brandGreen">
                    Watch episodes
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
     );
}
 
export default Dashboard;